import { render, staticRenderFns } from "./LikeSvg.vue?vue&type=template&id=273637dc&"
import script from "./LikeSvg.vue?vue&type=script&lang=js&"
export * from "./LikeSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports